var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 21.5,
    viewBox: "0 0 19.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-calculator",
    transform: "translate(15572.75 23329.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75,21.5h-4C2.32,21.5,0,19.18,0,13.75v-6C0,2.32,2.32,0,7.75,0h4c5.43,0,7.75,2.32,7.75,7.75v6C19.5,19.18,17.18,21.5,11.75,21.5Zm-4-20C3.14,1.5,1.5,3.14,1.5,7.75v6C1.5,18.36,3.14,20,7.75,20h4C16.36,20,18,18.36,18,13.75v-6c0-4.61-1.64-6.25-6.25-6.25Z",
    transform: "translate(-15572.75 -23329.75)",
    fill: "#f98525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.25,5.5h-6A2.253,2.253,0,0,1,0,3.25v-1A2.253,2.253,0,0,1,2.25,0h6A2.253,2.253,0,0,1,10.5,2.25v1A2.253,2.253,0,0,1,8.25,5.5Zm-6-4a.755.755,0,0,0-.75.75v1A.755.755,0,0,0,2.25,4h6A.755.755,0,0,0,9,3.25v-1a.755.755,0,0,0-.75-.75Z",
    transform: "translate(-15568.25 -23325.67)",
    fill: "#f98525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.99,2a1,1,0,0,1-.38-.08A.974.974,0,0,1,0,1,.986.986,0,0,1,.07.621.911.911,0,0,1,.29.291.609.609,0,0,1,.44.171.556.556,0,0,1,.61.081.7.7,0,0,1,.8.021a1,1,0,0,1,.9.27.955.955,0,0,1,.22.33A1,1,0,0,1,2,1a1,1,0,0,1-.3.71A.99.99,0,0,1,.99,2Z",
    transform: "translate(-15567.84 -23318.08)",
    fill: "#f98525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1,2A.99.99,0,0,1,0,1,.986.986,0,0,1,.07.62.911.911,0,0,1,.29.29.609.609,0,0,1,.44.17.556.556,0,0,1,.61.08.7.7,0,0,1,.8.02a.972.972,0,0,1,.58.06A.988.988,0,0,1,1.7.29a1.06,1.06,0,0,1,.22.33A1,1,0,0,1,2,1a1,1,0,0,1-.3.71A.984.984,0,0,1,1,2Z",
    transform: "translate(-15563.84 -23318.08)",
    fill: "#f98525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.99,1.988a1,1,0,0,1-.38-.08A.988.988,0,0,1,.29,1.7a1,1,0,0,1-.22-.33A.986.986,0,0,1,0,.988.986.986,0,0,1,.07.607.911.911,0,0,1,.29.278a1.034,1.034,0,0,1,1.41,0,1.017,1.017,0,0,1,.3.71,1.007,1.007,0,0,1-1.01,1Z",
    transform: "translate(-15559.84 -23318.068)",
    fill: "#f98525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1.01,2a.99.99,0,0,1-.71-.29A1,1,0,0,1,0,1,1.017,1.017,0,0,1,.3.287.878.878,0,0,1,.45.167.556.556,0,0,1,.62.077.7.7,0,0,1,.81.017a1.018,1.018,0,0,1,.9.27,1.738,1.738,0,0,1,.13.15l.09.18L1.99.8a1.355,1.355,0,0,1,.02.2,1,1,0,0,1-.3.71A.984.984,0,0,1,1.01,2Z",
    transform: "translate(-15567.85 -23314.076)",
    fill: "#f98525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M1.01,2a.99.99,0,0,1-.71-.29A1,1,0,0,1,0,1,1.017,1.017,0,0,1,.3.287a1.026,1.026,0,0,1,.9-.27.7.7,0,0,1,.19.06.556.556,0,0,1,.17.09,1.576,1.576,0,0,1,.15.12A1.007,1.007,0,0,1,2,1a.99.99,0,0,1-.99,1Z",
    transform: "translate(-15563.85 -23314.076)",
    fill: "#f98525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M.99,1.994a.99.99,0,0,1-.99-1A1.007,1.007,0,0,1,.29.284.988.988,0,0,1,.61.074,1.014,1.014,0,0,1,1.7.284a1.007,1.007,0,0,1,.29.71.974.974,0,0,1-.61.92A1.007,1.007,0,0,1,.99,1.994Z",
    transform: "translate(-15559.84 -23314.074)",
    fill: "#f98525"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculator);
export default __webpack_public_path__ + "static/media/Icon-calculator.6248a578ba6b2370a1ca3a58ef902a1f.svg";
export { ForwardRef as ReactComponent };